import { useEffect, useState } from 'react'
import { supabase } from '../../supabaseClient'
import {
  widgetCardStyle,
  labelStyle,
  valueStyle,
  footerStyle,
} from '../styles/widgetStyles'

function RiqAccuracyWidget() {
  const [accuracy, setAccuracy] = useState(null)
  const [hover, setHover] = useState(false)

  useEffect(() => {
    const fetchAccuracy = async () => {
      const { data, error } = await supabase
        .from('riq_metrics')
        .select('total_riq_interactions, riq_successful_answers')
        .single()

      if (!error && data) {
        const { total_riq_interactions, riq_successful_answers } = data
        const percentage =
          total_riq_interactions > 0
            ? Math.round((riq_successful_answers / total_riq_interactions) * 100)
            : 0
        setAccuracy(percentage)
      }
    }

    fetchAccuracy()
  }, [])

  return (
    <div
      style={widgetCardStyle(hover)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div style={labelStyle}>
        ✅ Riq Accuracy Score{' '}
        <span title="Percentage of queries where Riq gave a confident, data-backed answer.">ℹ️</span>
      </div>
      <div style={valueStyle}>{accuracy !== null ? `${accuracy}%` : '—'}</div>
      <div style={footerStyle}>Based on successful answers</div>
    </div>
  )
}

export default RiqAccuracyWidget
